import classnames from 'classnames'
import useThemeColors from 'hooks/useThemeColors'
import React from 'react'

import './style.css'

type HTMLHeaderProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadElement>, HTMLHeadElement>

const CardHeader = (props: HTMLHeaderProps) => {
  const { backgroundStyles, conversationHeaderTextStyles } = useThemeColors()

  return (
    <header
      {...props}
      className={classnames('drift-widget-card-header', props.className)}
      style={{ ...backgroundStyles, ...conversationHeaderTextStyles, ...props.style }}
    >
      <div className="drift-widget-card-header--content">
        {props.children}
      </div>
    </header>
  )
}

export default CardHeader
